'use strict';

var React = require('react');
var component = require('../Dropdown/component.js');
require('../Dropdown/Item.js');
require('../Dropdown/ItemGroup.js');
var component$1 = require('../Button/component.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Filter = React.forwardRef(({ active, count, cancelLabel = 'Cancel', children, dropDownVariant = 'align-left', isOpened, isValidateButtonDisabled = false, maxHeight, target, targetLabel = 'Open filter', targetVariant = 'rounded-secondary', validateLabel = 'Valid', onCancel, onOpenedChange, onValidate, }, ref) => {
    const shouldDisplayCounter = (count && count > 0) || false;
    return (React__default.default.createElement(styles.Styled.Container, null,
        shouldDisplayCounter && React__default.default.createElement(styles.Styled.Count, null, count),
        React__default.default.createElement(component.Dropdown, { isOpened: isOpened, maxHeight: maxHeight, onOpenedChange: onOpenedChange, target: target || (React__default.default.createElement(component$1.Button, { variant: targetVariant, active: active }, targetLabel)), variant: dropDownVariant, ref: ref },
            React__default.default.createElement(styles.Styled.DropdownItemContainer, null,
                children,
                React__default.default.createElement(styles.Styled.ButtonContainer, { space: 's', justifyContent: 'right' },
                    React__default.default.createElement(component$1.Button, { variant: 'secondary', onClick: onCancel }, cancelLabel),
                    React__default.default.createElement(component$1.Button, { variant: 'primary', onClick: onValidate, disabled: isValidateButtonDisabled }, validateLabel))))));
});

exports.Filter = Filter;
//# sourceMappingURL=component.js.map
